import { Browser, IBrowserVersion } from '@components/exportable/browser-upgrade-notice/interfaces/i-browser-information.interface'

export const supportedBrowserVersions: { [name: string]: IBrowserVersion } = {
  [Browser.CHROME.userAgentLookup]: { major: 80, minor: 0 },
  [Browser.SAFARI.userAgentLookup]: { major: 14, minor: 0 },
  [Browser.FIREFOX.userAgentLookup]: { major: 70, minor: 0 },
  [Browser.EDGE.userAgentLookup]: { major: 79, minor: 0 },
}

export const browserDownloadList: { [name: string]: string } = {
  [Browser.CHROME.userAgentLookup]: 'https://www.google.com/chrome/#updates',
  [Browser.EDGE.userAgentLookup]: 'https://www.microsoft.com/en-us/edge?ep=313&form=MA13M0&es=40',
  [Browser.FIREFOX.userAgentLookup]: 'https://www.mozilla.org/en-GB/firefox/new/',
  [Browser.SAFARI.userAgentLookup]: 'https://www.apple.com/uk/safari/',
}
